<template>
    <sdDropdown placement="bottomRight" :action="['click']">
        <template v-slot:overlay>
            <router-link @click="() => onFlagChangeHandle('tr')" to="#">
              <img :src="require('@/static/img/flag/tr.png')" alt="" />
              <span>Türkçe</span>
            </router-link>
            <router-link @click="() => onFlagChangeHandle('en')" to="#">
              <img :src="require('@/static/img/flag/en.png')" alt="" />
              <span>English</span>
            </router-link>
        </template>
        <a to="#" class="head-example">
          <img :src="require(`@/static/img/flag/${flag}.png`)" alt="" />
        </a>
      </sdDropdown>
</template>

<script>
import { useStore, mapGetters } from 'vuex';

export default {
    name: "LanguageSetter",
    data() {
    return {
      flag: 'tr',
      useStore: useStore(),
    };
  },
  methods: {
    onFlagChangeHandle: function(value) {
      this.flag = value;
      localStorage.setItem('i_lang', value);
      this.useStore.dispatch('i18n/setLang', value);
      this.$router.go();
    },
  },
  created() {
    this.flag = this.app;
  },
  computed: {
    ...mapGetters({
      app: 'i18n/i_lang',
    }),
  },
}
</script>